export default __webpack_public_path__ + "static/media/ProfilePic.7c2f4490.svg";